<template>
  <vs-popup :active.sync="open"
            :buttons-hidden="true"
            @close="onClickClose()"
            class="assign-formulation-stock-inventory-from-wo-pop-up"
            title="AVAILABLE STOCK INVENTORIES FOR ASSIGN">
    <vx-card no-shadow>
      <vs-table
        :data="data"
        :hoverFlat="true"
        id="assign-formulation-stock-inventory-pop-up"
        stripe>

        <template slot="thead">
          <vs-th width="20%"  class="text-xs" sort-key="sundry_item_code">BATCH CODE</vs-th>
          <vs-th width="10%"  class="text-xs">MANUFACTURE DATE</vs-th>
          <vs-th width="10%"  class="text-xs">EXP DATE</vs-th>
          <vs-th width="10%"  class="text-xs">MLOR %</vs-th>
          <vs-th width="10%" class="text-xs">BATCH QTY (KG)</vs-th>
          <vs-th width="10%" class="text-xs">COMPLETED/AVAILABLE QTY (KG)</vs-th>
          <vs-th width="20%" class="text-xs">STATUS</vs-th>
          <vs-th width="10%" class="text-xs">ACTION</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

            <vs-td class="text-primary font-semibold" :data="data[indextr].work_order_code">
              {{ data[indextr].work_order_code}}
            </vs-td>

            <vs-td :data="data[indextr].manufacture_date">
              {{ data[indextr].manufacture_date}}
            </vs-td>

            <vs-td :data="data[indextr].expiration_date">
              {{ data[indextr].expiration_date}}
            </vs-td>

            <vs-td :data="data[indextr].mlor">
              {{ data[indextr].mlor}}
            </vs-td>

            <vs-td :data="data[indextr].total_quantity">
              {{ toFixed(data[indextr].total_quantity)}}
            </vs-td>


            <vs-td :data="data[indextr].completed_quantity">
              {{ toFixed(data[indextr].completed_quantity)}}
            </vs-td>

            <vs-td :data="data[indextr].status">
              <vs-chip transparent :color="'dark'" style="border-radius: 0" class="w-32">
                {{ data[indextr].status}}
              </vs-chip>
            </vs-td>

            <vs-td>
              <vx-tooltip style="z-index: 9999" text="Assign from this stock" position="top" v-if="data[indextr].status === 'In_Stock'">
                <vs-button class="ml-3"
                           @click.stop="onClickAssignFormulation(data[indextr].id, data[indextr].status, data[indextr].completed_quantity)"
                           size="small" color="primary" type="border" icon-pack="feather" icon="icon-share"></vs-button>
              </vx-tooltip>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
      <assign-formulation-stock-pop-up v-on:refreshData="onClickClose" ref="assignFormulationStockPopUp"/>

    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  import AssignFormulationStockPopUp from "./AssignFormulationStockPopUp";

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      data: [],
      formulation_id: '',
      item_id: ''
    }
  }

  export default {
    name: 'AssignFormulationStockFromWorkOrderPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(data, formulation_id, item_id = null) {
        try {
          await Object.assign(this.$data, initialState());
          this.data = data
          this.formulation_id = formulation_id
          this.item_id = item_id
          this.open = true;
        } catch (error) {

        }
      },
      onClickAssignFormulation(inventory_id, status, completed_quantity) {
        if(status === 'In_Stock') {
          this.$refs.assignFormulationStockPopUp.openPopup(this.formulation_id, inventory_id, completed_quantity, this.item_id)
        }
      },
      onClickClose() {
        this.$emit('refreshData')
        this.open = false
      },
      toFixed(number) {
        return Number(number).toFixed(2)
      }
    },
    async mounted() {

    },
    components: {
      'v-select': vSelect,
      AssignFormulationStockPopUp
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .assign-formulation-stock-inventory-from-wo-pop-up >>> .vs-popup {
    min-height: 40% !important;
    min-width: 70% !important;
  }

</style>
